import { MemberRole, } from '@lucidlink/dto/validation';
import { prepareServiceAdminMember, prepareServiceCollaboratorMember, } from '../member';
import { prepareInvitationCommon } from './prepare-invitation-common';
export const prepareServiceAccountInvitation = async ({ adminCrypto, workspaceId, accountKey, creatorRole, targetRole, }) => {
    const adminKeys = await adminCrypto.verifyAndGetAdminKeys();
    const [workspaceCommonKey, everyoneKeys, workspaceSecretKey] = await Promise.all([
        adminCrypto.getWorkspaceCommonKey(),
        adminCrypto.verifyAndGetEveryoneKeys(),
        adminCrypto
            .getSsoCrypto()
            .then((ssoCrypto) => ssoCrypto.verifyAndGetSsoSecretKey()),
    ]);
    const invitationCommon = await prepareInvitationCommon({
        workspaceId,
        adminKeys,
        workspaceCommonKey,
        everyonePrivateKey: everyoneKeys.privateKey,
        workspaceSecretKey,
    });
    const isAdmin = targetRole
        ? targetRole === MemberRole.SERVICE_ADMIN
        : creatorRole === MemberRole.ADMIN || creatorRole === MemberRole.OWNER;
    const serviceAccountMember = isAdmin
        ? await prepareServiceAdminMember({
            workspaceId,
            invitationKeys: invitationCommon.invitationKeys,
            adminKeys,
            accountKey,
        })
        : await prepareServiceCollaboratorMember({
            workspaceId,
            invitationKeys: invitationCommon.invitationKeys,
            adminKeys,
            accountKey,
        });
    return {
        ...invitationCommon,
        invitation: {
            ...invitationCommon.invitation,
            member: serviceAccountMember,
        },
    };
};
